import { useEffect, useState } from "react";

const KEY = "meranggi_theme";

export function applyTheme(mode) {
  const dark = mode === "dark" || (mode === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", dark);
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", dark ? "#1C1C1E" : "#F5F5F7");
}

export function initTheme() {
  applyTheme(localStorage.getItem(KEY) || "light");
}

export function useTheme() {
  const [mode, setMode] = useState(() => localStorage.getItem(KEY) || "light");
  useEffect(() => {
    localStorage.setItem(KEY, mode);
    applyTheme(mode);
    if (mode !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const h = () => applyTheme("system");
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, [mode]);
  return [mode, setMode];
}
